import { render, staticRenderFns } from "./createAssign.vue?vue&type=template&id=5aa00050"
import script from "./createAssign.vue?vue&type=script&lang=js"
export * from "./createAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports